module.exports = __webpack_public_path__ + "static/savingscard-0b654e42f3ab1acdfd56b709742cbc37.jpg";